export default __webpack_public_path__ + "static/media/eternal-youth.8b3b7589.mp3";